/* eslint-disable */
export default {
	print: () => {
		if (document.readyState !== 'complete') {
			return;
		}
		$('script').remove();
		$('body').addClass('htmltopdf');

			let printHTML = () => {

			let copy = $(document.documentElement).clone(true);

			let styleTags = copy.find('style');
			if (styleTags && styleTags.length) {
				for (let i = 0; i< styleTags.length; i++) {
					if (styleTags[i].innerHTML.indexOf('bootstrap') > 0) {
						 $(styleTags[i]).detach();
					}
				}
			}
			let link = copy.find('link');
			if (link && link.length) {
				for (let i = 0; i< link.length; i++) {
					$(link[i]).detach();
				}
			}

			let html = '<!DOCTYPE html>\n' + copy[0].outerHTML;

			if (html.indexOf('Activate to launch comment') > 0) {
				html = html.replace(/Activate to launch comment card/, '');
			}
			// This series of funny encoding steps is copied from TD Ameritrade's code. I don't know
			// why these steps are required, but removing any of the encoding steps breaks things.
			html = unescape(encodeURIComponent(html));
			html = 'B64ENC' + base64Encode(html);

			const url = '/advisor/investments/print';
			const form = $('body').append('<form id="print-form" method="post" action="' + url + '" target="_blank"></form>');

			let text;
			let x;
			let numChunks = Math.ceil(html.length / CHUNK_SIZE);

			for (x = 0; x < numChunks; x++) {
				text = html.substr(x * CHUNK_SIZE, CHUNK_SIZE);
				$('#print-form').append($('<input type="hidden" name="html" />').val(text));
			}
			let viewerWidth = 1122;
			if (viewerWidth) {
				$('#print-form').append($("<input type='hidden' name='ViewerWidth' />").val(viewerWidth));
			}
			$('#print-form').submit();
			$('#print-form').remove();

			// Now undo the changes that we made to the styles for the benefit of HtmlToPdf.
			$('body').removeClass('htmltopdf');

			if (isieBrowser) {
				$('body').addClass('isie-browser');
			}

			newCssNode.after(oldCssNode);
			newCssNode.remove();
		};
		printHTML();
	}
};

let CHUNK_SIZE = 2000;

const base64Encode = function (sIn) {
	const sBase64Forward = {
		A: 0, B: 1, C: 2, D: 3, E: 4, F: 5, G: 6, H: 7, I: 8, J: 9,
		K: 10, L: 11, M: 12, N: 13, O: 14, P: 15, Q: 16, R: 17, S: 18, T: 19,
		U: 20, V: 21, W: 22, X: 23, Y: 24, Z: 25, a: 26, b: 27, c: 28, d: 29,
		e: 30, f: 31, g: 32, h: 33, i: 34, j: 35, k: 36, l: 37, m: 38, n: 39,
		o: 40, p: 41, q: 42, r: 43, s: 44, t: 45, u: 46, v: 47, w: 48, x: 49,
		y: 50, z: 51, 0: 52, 1: 53, 2: 54, 3: 55, 4: 56, 5: 57, 6: 58, 7: 59,
		8: 60, 9: 61, '+': 62, '/': 63
	};
	const sBase64Reverse = [
		'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R',
		'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j',
		'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '0', '1',
		'2', '3', '4', '5', '6', '7', '8', '9', '+', '/'
	];

	let count = sIn.length;
	let i;
	let index = -1;
	let iBits;
	let sOut = new Array(Math.ceil(count * 4 / 3)); //pre-allocate the array
	const chars = sBase64Reverse;

	for (i = 0; i < count; i += 3) {
		iBits = (sIn.charCodeAt(i) << 16)
		+ ((sIn.charCodeAt(i + 1) & 0xff) << 8)
		+ (sIn.charCodeAt(i + 2) & 0xff);

		sOut[++index] = chars[iBits >> 18 & 0x3f];
		sOut[++index] = chars[iBits >> 12 & 0x3f];
		//tried to unroll this, but couldn't get results to match
		sOut[++index] = (i > count - 2) ? '=' : chars[iBits >> 6 & 0x3f];
		sOut[++index] = (i > count - 3) ? '=' : chars[iBits & 0x3f];
	}
	return sOut.join('');
};
